export const BREAKPOINT_TABLET = 1024;
export const BREAKPOINT_DESKTOP = 1280;

export const FULL_WIDTH_ROUTES = [
  /^\/requests(\/.*)?$/,
  /^\/$/,
];
